export type ColorScheme = 'default' | 'ocean' | 'forest' | 'sunset';

export interface ColorSchemeData {
  id: ColorScheme;
  name: string;
  homeA: {
    bg: string;
    border: string;
    text: string;
    color: string; // Kolor kółka
  };
  homeB: {
    bg: string;
    border: string;
    text: string;
    color: string; // Kolor kółka
  };
  eventAccent: string; // Stały akcent dla wskaźników wydarzeń (kółko, pasek all-day)
}

export const colorSchemes: Record<ColorScheme, ColorSchemeData> = {
  default: {
    id: 'default',
    name: 'Klasyczny (Czerwony/Zielony)',
    homeA: {
      bg: 'from-red-50 to-pink-50',
      border: 'border-red-200',
      text: 'text-red-800',
      color: '#ef4444' // red-500
    },
    homeB: {
      bg: 'from-teal-50 to-cyan-50',
      border: 'border-teal-200',
      text: 'text-teal-800',
      color: '#14b8a6' // teal-500
    }
    ,
    eventAccent: '#1e40af' // blue-800 – granatowy akcent na czerwieni/tealu
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean (Niebieski/Fioletowy)',
    homeA: {
      bg: 'from-blue-50 to-indigo-50',
      border: 'border-blue-200',
      text: 'text-blue-800',
      color: '#3b82f6' // blue-500
    },
    homeB: {
      bg: 'from-purple-50 to-violet-50',
      border: 'border-purple-200',
      text: 'text-purple-800',
      color: '#a855f7' // purple-500
    },
    eventAccent: '#d97706' // amber-600 – mocno kontrastuje z niebieskim/fioletem
  },
  forest: {
    id: 'forest',
    name: 'Las (Zielony/Brązowy)',
    homeA: {
      bg: 'from-green-50 to-emerald-50',
      border: 'border-green-200',
      text: 'text-green-800',
      color: '#22c55e' // green-500
    },
    homeB: {
      bg: 'from-amber-50 to-orange-50',
      border: 'border-amber-200',
      text: 'text-amber-800',
      color: '#f59e0b' // amber-500
    },
    eventAccent: '#0d9488' // teal-600 – dobrze kontrastuje z zielenią i bursztynem
  },
  sunset: {
    id: 'sunset',
    name: 'Zachód słońca (Pomarańczowy/Różowy)',
    homeA: {
      bg: 'from-orange-50 to-red-50',
      border: 'border-orange-200',
      text: 'text-orange-800',
      color: '#f97316' // orange-500
    },
    homeB: {
      bg: 'from-pink-50 to-rose-50',
      border: 'border-pink-200',
      text: 'text-pink-800',
      color: '#ec4899' // pink-500
    },
    eventAccent: '#dc2626' // red-600 – wyraźny przy pomarańczach/różach
  }
};

export const getColorScheme = (scheme: ColorScheme): ColorSchemeData => {
  return colorSchemes[scheme] || colorSchemes.default;
};